import auth from './auth'
import cardsReducer from './cardsSlice'
import { configureStore } from '@reduxjs/toolkit'
import { firebaseReducer } from 'react-redux-firebase'
import { firestoreReducer } from 'redux-firestore'
import { getFirebase } from 'react-redux-firebase'
import thunk from 'redux-thunk'

export const store = configureStore({
  middleware: [thunk.withExtraArgument(getFirebase)],
  reducer: {
    auth,
    cards: cardsReducer,
    firebase: firebaseReducer,
    firestore: firestoreReducer,
  },
})
